import type { QueryClient } from "@tanstack/react-query";
import { forgetCsrfToken } from "@/api/client";

/**
 * Al caducar o cerrarse la sesión no puede quedar nada de lo que vio esa persona: se cancelan las lecturas en
 * vuelo y se vacía la caché entera (`setQueryData(…, undefined)` no borra nada en TanStack Query v5, y con la
 * sesión «viva» en caché la pantalla de entrada devolvería a la persona a la página que acaba de perder).
 */
export function olvidarSesion(queryClient: QueryClient): void {
  forgetCsrfToken();
  void queryClient.cancelQueries();
  queryClient.clear();
}
